export * from './app-aside.component';



// WEBPACK FOOTER //
// ./src/app/components/app-aside/index.ts